export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PostList.vue?vue&type=template&id=7942b51d&"


//////////////////
// WEBPACK FOOTER
// ./assets/js/components/PostList.vue?vue&type=template&id=7942b51d&
// module id = 422
// module chunks = 0